import styled from '@emotion/styled';
import {colors, mq} from 'ui/config';
import {Hr, SlideTitle as SlideTitleUI, Img, MainTitle as MainTitleUI, HeadlineMedium} from 'ui';
import {Link} from 'react-router-dom';
import arrowBack from 'assets/img/arrowBack.svg';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  marginBottom: 40,
  paddingBottom: 40,
});

export const Title = styled(SlideTitleUI)({
  position: 'relative',
  color: 'white',

  [mq('small')]: {
    fontSize: 35,
  },
});

export const FormationsCover = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  width: '100vw',
  height: 350,
  paddingTop: 69,
  [mq('small')]: {
    paddingTop: 60,
  },
});

export const FormationsContent = styled('div')({
  padding: 20,
  backgroundColor: colors.greyLight,
});

export const Image = styled(Img)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100vw',
  height: 350,
});

export const BackLink = styled(Link)({
  position: 'absolute',
  top: 30,
  left: 20,
  width: 32,
  height: 32,
  backgroundColor: 'transparent',
  backgroundImage: `url(${arrowBack})`,
  backgroundPosition: 'center',
  [mq('small')]: {
    top: 20,
  },
});

export const MainTitle = styled(MainTitleUI)({
  position: 'relative',
  zIndex: 10,
  [mq('small')]: {
    fontSize: 28,
  },
});

export const Mask = styled('div')({
  position: 'absolute',
  left: 0,
  bottom: 0,
  width: '100%',
  height: 97,
  backgroundImage: 'linear-gradient(180deg, rgba(56,40,24,0.00) 0%, #382818 100%)',
});

export const MediumTitle = styled(HeadlineMedium)({
  position: 'relative',
  marginLeft: 17,
  marginRight: 17,
  zIndex: 10,
  marginTop: -10,
  [mq('small')]: {
    marginLeft: 10,
    marginRight: 10,
  },
});

export const FormationsHr = styled(Hr)({
  marginBottom: 20,
  marginTop: 40,
});
